if (!customElements.get('announcement-ticker')) {
  class AnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.cb-announce__item'));
      if (!this.items.length) return;

      this.duration = parseInt(this.dataset.duration, 10) || 6000;
      this.current = 0;

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearTimeout(this._timer);
        } else {
          this.scheduleNext();
        }
      });

      this.showItem(0);
      if (this.items.length > 1) this.scheduleNext();
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
    }

    showItem(index) {
      this.items.forEach((item) => item.classList.remove('is-active'));
      const target = this.items[index];
      if (!target) return;
      void target.offsetWidth;
      target.classList.add('is-active');
    }

    scheduleNext() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this.advance(), this.duration);
    }

    advance() {
      this.current = (this.current + 1) % this.items.length;
      this.showItem(this.current);
      this.scheduleNext();
    }
  }

  customElements.define('announcement-ticker', AnnouncementTicker);
}